module.exports = __webpack_public_path__ + "img/vertical_3_7_8017.126c4c32.png";